import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Store } from '@ngrx/store';
import { Observable, Subscription, map, startWith } from 'rxjs';
import { AppState } from 'src/app/core/app.state';
import { ICatalog } from 'src/app/features/catalogs/models/catalogs.models';

@Component({
  selector: 'app-insert-catalogs-product',
  templateUrl: './insert-catalogs-product.component.html',
  styleUrls: ['./insert-catalogs-product.component.scss']
})
export class InsertCatalogsProductComponent implements OnInit {
  @Input() selectedCatalogsO: ICatalog[] = [];
  selectedCatalogs: ICatalog[] = [];
  @Output() saveCatalogs = new EventEmitter<ICatalog[]>();
  @Output() cancelCatalogs = new  EventEmitter<null>();

  catalogs$: Observable<ICatalog[]> = this.store.select((state)=> state.catalogs.allCatalogs);
  private subscriptions: Subscription[] = [];
  catalogs: ICatalog[] = [];
  allCatalogs: ICatalog[] = [];
  search = new FormControl();
  constructor(
    private store: Store<AppState>,
  ) { }

  ngOnInit(): void {
    this.selectedCatalogs = [...this.selectedCatalogsO]
    const sub1 = this.catalogs$.subscribe(catalogs => {      
      this.allCatalogs = catalogs
      this.filterCatalogs()
    });


    const sub2 = this.search.valueChanges.pipe(
      startWith(''),
      map(searchTerm => searchTerm.toLowerCase())
    ).subscribe(searchTerm => {
      this.filterCatalogs(searchTerm);
    })

    this.subscriptions.push(sub1, sub2)
  }

  filterCatalogs(searchTerm: string = ''): void {    
    this.catalogs = this.allCatalogs.filter(catalog =>
      !this.selectedCatalogs.some(selectedCatalog => selectedCatalog.id === catalog.id) &&
      (catalog.name?.toLowerCase().includes(searchTerm))
    );
  }

  addCatalog(catalog: ICatalog) {
    this.selectedCatalogs.push(catalog);
    this.filterCatalogs(this.search.value ? this.search.value : '');
  }

  removeCatalog(catalog: ICatalog) {
    this.selectedCatalogs = this.selectedCatalogs.filter(l => l.id !== catalog.id);
    this.filterCatalogs(this.search.value ? this.search.value : '');
  }

  drop(event: CdkDragDrop<ICatalog[]>) {
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      transferArrayItem(
        event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex,
      );
    }
    this.filterCatalogs(this.search.value ? this.search.value : '');
  }

  trackByFn(index: number, item: ICatalog) {
    return item.id;
  }

  save() {
    this.selectedCatalogsO = [...this.selectedCatalogs];
    this.saveCatalogs.emit(this.selectedCatalogsO);
  }

  cancel(){
    this.cancelCatalogs.emit()
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((sub => sub.unsubscribe()))
  }

}
